export default __webpack_public_path__ + "static/lego-unicorn-man-621080e631775c68f6c11b02c80ec35e.jpg";